import React from 'react';
import { Page, LayoutComposer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';

import css from './HowItWorksPage.module.css';

const CameraIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="13" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const PriceIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="12"
      y1="1"
      x2="12"
      y2="23"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShipIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="3"
      width="15"
      height="13"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M16 8h4l3 5v3h-7V8z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <circle cx="5.5" cy="18.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="18.5" cy="18.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const WalletIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2"
      y="4"
      width="20"
      height="16"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M2 10h20" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="18" cy="15" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const SearchIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <line
      x1="21"
      y1="21"
      x2="16.65"
      y2="16.65"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const CardIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="4"
      width="22"
      height="16"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line x1="1" y1="10" x2="23" y2="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <line
      x1="5"
      y1="15"
      x2="10"
      y2="15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const PackageIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg className={css.stepIcon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 3l-8 4v5c0 5.25 3.4 10.15 8 11 4.6-.85 8-5.75 8-11V7l-8-4z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 12l2 2 4-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SELLER_STEPS = [
  {
    icon: CameraIcon,
    titleId: 'HowItWorksPage.sellerStep1Title',
    textId: 'HowItWorksPage.sellerStep1Text',
  },
  {
    icon: PriceIcon,
    titleId: 'HowItWorksPage.sellerStep2Title',
    textId: 'HowItWorksPage.sellerStep2Text',
  },
  {
    icon: ShipIcon,
    titleId: 'HowItWorksPage.sellerStep3Title',
    textId: 'HowItWorksPage.sellerStep3Text',
  },
  {
    icon: WalletIcon,
    titleId: 'HowItWorksPage.sellerStep4Title',
    textId: 'HowItWorksPage.sellerStep4Text',
  },
];

const BUYER_STEPS = [
  {
    icon: SearchIcon,
    titleId: 'HowItWorksPage.buyerStep1Title',
    textId: 'HowItWorksPage.buyerStep1Text',
  },
  {
    icon: CardIcon,
    titleId: 'HowItWorksPage.buyerStep2Title',
    textId: 'HowItWorksPage.buyerStep2Text',
  },
  {
    icon: PackageIcon,
    titleId: 'HowItWorksPage.buyerStep3Title',
    textId: 'HowItWorksPage.buyerStep3Text',
  },
  {
    icon: ShieldIcon,
    titleId: 'HowItWorksPage.buyerStep4Title',
    textId: 'HowItWorksPage.buyerStep4Text',
  },
];

const StepCard = ({ icon: Icon, titleId, textId, stepNumber }) => (
  <div className={css.stepCard}>
    <div className={css.stepNumber}>{stepNumber}</div>
    <Icon />
    <div className={css.stepContent}>
      <h3 className={css.stepTitle}>
        <FormattedMessage id={titleId} />
      </h3>
      <p className={css.stepText}>
        <FormattedMessage id={textId} />
      </p>
    </div>
  </div>
);

const HowItWorksPage = ({ intl }) => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <Page
      title={intl.formatMessage({ id: 'HowItWorksPage.schemaTitle' })}
      description={intl.formatMessage({ id: 'HowItWorksPage.schemaDescription' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: intl.formatMessage({ id: 'HowItWorksPage.schemaTitle' }),
        description: intl.formatMessage({ id: 'HowItWorksPage.schemaDescription' }),
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header">
                <TopbarContainer currentPage="HowItWorksPage" />
              </Topbar>
              <Main as="main" className={css.main}>
                <section className={css.section}>
                  <h2 className={css.sectionTitle}>
                    <FormattedMessage id="HowItWorksPage.sellerSectionTitle" />
                  </h2>
                  <p className={css.sectionSubtitle}>
                    <FormattedMessage id="HowItWorksPage.sellerSectionSubtitle" />
                  </p>
                  <div className={css.stepsGrid}>
                    {SELLER_STEPS.map((step, i) => (
                      <StepCard key={step.titleId} {...step} stepNumber={i + 1} />
                    ))}
                  </div>
                </section>

                <section className={css.sectionAlt}>
                  <h2 className={css.sectionTitle}>
                    <FormattedMessage id="HowItWorksPage.buyerSectionTitle" />
                  </h2>
                  <p className={css.sectionSubtitle}>
                    <FormattedMessage id="HowItWorksPage.buyerSectionSubtitle" />
                  </p>
                  <div className={css.stepsGrid}>
                    {BUYER_STEPS.map((step, i) => (
                      <StepCard key={step.titleId} {...step} stepNumber={i + 1} />
                    ))}
                  </div>
                </section>

                <section className={css.ctaSection}>
                  <h2 className={css.ctaTitle}>
                    <FormattedMessage id="HowItWorksPage.ctaTitle" />
                  </h2>
                  <div className={css.ctaButtons}>
                    <a href="/shop" className={css.ctaButton}>
                      <FormattedMessage id="HowItWorksPage.ctaShop" />
                    </a>
                    <a href="/sell" className={css.ctaButtonOutline}>
                      <FormattedMessage id="HowItWorksPage.ctaSell" />
                    </a>
                  </div>
                </section>
              </Main>
              <FooterContainer />
            </>
          );
        }}
      </LayoutComposer>
    </Page>
  );
};

export default injectIntl(HowItWorksPage);
